import React from 'react';
import PropTypes from 'prop-types';
import { Link as v4Link } from 'react-router-dom';

// constellation
import { Gleam, Text } from '@zillow/constellation';

// style
import {
    StyledCountBadge,
    StyledIconChevronRight,
    StyledIconError,
    StyledIconSuccess,
    StyledLink,
    StyledPropertyPanel,
    StyledPropertyPanelContent,
    StyledPropertyPanelIconContainer,
    StyledPropertyPanelTitle,
} from './StyledComponents';

function PropertyPanel(props) {
    const {
        title,
        message,
        isDisabled,
        urlPath,
    } = props;

    const to = isDisabled === false ? urlPath : null;

    const getIcon = () => {
        const { badgeCount, iconName } = props;

        switch (iconName) {
            case 'badgeCount':
                return (
                    <StyledCountBadge>
                        <Gleam
                            count={badgeCount}
                            maxCount={99}
                            maxSuffix={true}
                        />
                    </StyledCountBadge>
                );

            case 'success':
                return <StyledIconSuccess />;
            case 'error':
                return <StyledIconError />;
            default:
                return null;
        }
    };

    const handlePanelClick = (event) => {
        event.preventDefault();

        if (to) {
            // if to does not starts with '/' then open in a new tab
            const target = to.charAt(0) !== '/' ? '_blank' : '_self';

            window.router.updateLocation(to, target);
        }
    };

    return (
        <StyledLink
            className="SOHPropertyPanel-Anchor"
            to={to}
            target="_blank"
            escape={true}
            reactRouterLink={v4Link}
        >
            <StyledPropertyPanel className="SOHPropertyPanel" onClick={handlePanelClick}>
                <StyledPropertyPanelContent className="SOHPropertyPanel-Content">
                    <StyledPropertyPanelTitle
                        className="SOHPropertyPanel-Title"
                        fontType="smallbody"
                    >
                        {title}
                    </StyledPropertyPanelTitle>
                    <Text fontType="smallbody">{message}</Text>
                </StyledPropertyPanelContent>
                <StyledPropertyPanelIconContainer className="SOHPropertyPanel-IconContainer">
                    {getIcon()}
                    {isDisabled === false && <StyledIconChevronRight size="xs" />}
                </StyledPropertyPanelIconContainer>
            </StyledPropertyPanel>
        </StyledLink>
    );
}

PropertyPanel.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    badgeCount: PropTypes.number,
    iconName: PropTypes.string,
    urlPath: PropTypes.string,
};

PropertyPanel.defaultProps = {
    badgeCount: 0,
    iconName: null,
    urlPath: null,
};

export default PropertyPanel;
